import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonHeader, IonContent } from '@ionic/react'
import { storeMobx } from 'restaurant'
import { modalLayer } from '@utils'
import { useMktConfigInit } from '@common/hooks'
import { each } from '@dt/fe-utils/dist/lodash'
import { ListShow, ResultAlert, CouponItem } from '@cps'
import { mktConfigMobx } from '@mobxStore'
import './index.scss'

interface IProps {
  data: any;
  cards: any;
  couponDetails: any;
  reject?: () => void;
  resolve?: () => void;
}

const CouponDetailModal: FC<IProps> = (props: IProps) => {
  const {
    data,
    couponDetails,
    cards,
    reject
  } = props
  const { storeIdToStore } = storeMobx
  const getStoreName = (stores: any[]) => {
    const names: any = []
    each(stores, (item: number) => {
      if (storeIdToStore[item]) names.push(storeIdToStore[item].storeName)
    })
    return names
  }
  const renderProductName = (product) => {
    let str = product.productName || product.categoryName || ''
    if (product.scaleName) {
      return `${str}(${product.scaleName})`
    }
    return `${str}${product.categoryNo && !product.productNo && !product.scaleNo
      ? `(${i18n.t('mkt.pointCard.allCatgory')})`
      : ''
    }`
  }
  const viewCoupons = () => {
    modalLayer(ResultAlert, {
      title: i18n.t('mkt.pointCard.activeRewards'),
      btnTitle: i18n.t('pay.acknowledged'),
      children:
        data.coupons.map((item: any, index: number) => {
          const hasItem: any = couponDetails[item.couponId]
          return hasItem && (
            <div className='coupon-block' key={`${index}-${item.couponId}`}>
              <CouponItem
                type='get'
                couponInfo={hasItem}
                cnt={item.couponCnt > 1 ? item.couponCnt : ''}
              >
              </CouponItem>
            </div>
          )
        }),
    }).then(() => { }, () => { })
  }

  useMktConfigInit(true)

  return (
    <IonModal
      cssClass='point-detail-modal'
      isOpen
      showBackdrop
      backdropDismiss
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span>{i18n.t('mkt.market.marketDetail')}</span>
        <i className='iconfont icon-close' onClick={reject}></i>
      </IonHeader>
      <IonContent>
        <div className='modal-body'>
          {data.extra.copywriting && (
            <div className='detail-des'>
              <div>{i18n.t('mkt.activity.introduce')}</div>
              <div className='des'>{data.extra.copywriting}</div>
            </div>
          )}
          <div className='detail-des'>
            <div>{i18n.t('mkt.pointCard.rule')}</div>
            <div className='info-area'>
              <div className='info-item'>
                <div className='left'>
                  {i18n.t('mkt.pointCard.rule')}:
                </div>
                <div className='right'>
                  {data.orderFee
                    ? i18n.t('mkt.pointCard.getRuleByPrice', {
                      n: data.orderFee,
                    })
                    : i18n.t('mkt.pointCard.getRuleByProduct')}
                </div>
              </div>
              <div className='info-item'>
                <div className='left'>
                  {i18n.t('mkt.pointCard.limit')}:
                </div>
                <div className='right'>
                  {i18n.t(
                    data.collectPointIfOverly
                      ? 'mkt.pointCard.noLimit'
                      : 'mkt.pointCard.max1'
                  )}
                </div>
              </div>
              <div className='info-item'>
                <div className='left'>
                  {i18n.t('mkt.pointCard.countLimit')}:
                </div>
                <div className='right'>
                  {data.extra?.participateNum
                    ? i18n.t('mkt.pointCard.maxCount', {
                      n: data.extra?.participateNum,
                    })
                    : i18n.t('mkt.pointCard.noLimit')}
                </div>
              </div>
              <div className='info-item'>
                <div className='left'>
                  {i18n.t('mkt.pointCard.channel')}:
                </div>
                <div className='right'>
                  {data.channelEatType && !data.channelEatType.isAll
                    ? data.channelEatType.channels.map((item: any) => {
                      if (item.enable) {
                        const eatTypes = item?.eatTypes?.length ? item.eatTypes.map((i: string) => i18n.t(`menu.${i}`)) : []
                        return `${mktConfigMobx.eatTypeAndChannelMap[item.key]?.value || item.key}${eatTypes.length ? `(${eatTypes.join(',')})` : ''}`
                      } else {
                        return ''
                      }
                    }).filter((item: any) => !!item).join(',')
                    : i18n.t('mkt.market.allChannels')}
                </div>
              </div>
              {/* <div className='info-item'>
                <div className='left'>
                  {i18n.t('mkt.pointCard.eatType')}:
                </div>
                <div className='right'>
                  {getChannel(data.eatTypes).eatType.map((item: any) => {
                    return i18n.t(`mkt.pointCard.${item}`)
                  }).join(',')}
                </div>
              </div> */}
              <div className='info-item'>
                <div className='left'>
                  {i18n.t('mkt.pointCard.member')}:
                </div>
                <div className='right'>
                  {data.isAllMember && i18n.t('mkt.pointCard.allMember')}
                  {!data.isAllMember && (
                    <ListShow
                      data={cards.map((item) => item.cardName || '')}
                    >
                    </ListShow>
                  )}
                </div>
              </div>
              {data.orderFee ? '' : (
                <>
                  {data.productRelation === 'all' || data.products?.length ? (
                    <div className='info-item'>
                      <div className='left'>
                        {i18n.t(`mkt.pointCard.${data.productRelation === 'excluded' ? 'excludeProduct' : 'product'}`)}:
                      </div>
                      <div className='right'>
                        {data.productRelation === 'all' ? (
                          i18n.t('mkt.coupon.allMealApplicable')
                        ) : (
                          <ListShow
                            data={data.products.map(renderProductName)}
                          >
                          </ListShow>
                        )}
                      </div>
                    </div>
                  ) : ''}
                  {data.productComboRelation === 'all' || data.comboProducts?.length ? (
                    <div className='info-item'>
                      <div className='left'>
                        {i18n.t(`mkt.pointCard.${data.productComboRelation === 'excluded' ? 'excludeCombo' : 'combo'}`)}:
                      </div>
                      <div className='right'>
                        {data.productComboRelation === 'all' ? (
                          i18n.t('mkt.coupon.allComboApplicable')
                        ) : (
                          <ListShow
                            data={data.comboProducts.map(renderProductName)}
                          >
                          </ListShow>
                        )}
                      </div>
                    </div>
                  ) : ''}
                </>
              )}
              <div className='info-item'>
                <div className='left'>
                  {i18n.t('mkt.pointCard.store')}:
                </div>
                <div className='right'>
                  {data.isAllStore && i18n.t('mkt.pointCard.allStore')}
                  {!data.isAllStore && (
                    <ListShow data={getStoreName(data.stores)}></ListShow>
                  )}
                </div>
              </div>
              {
                !!data.products?.length &&
                  <div className='info-item'>
                    <div className='left'>{i18n.t('mkt.pointCard.preferentialFood')}: </div>
                    <div className='right'>
                      {
                        data?.extra?.discountPartake
                          ? <span>{i18n.t('mkt.pointCard.notParticipating')}</span>
                          : (
                            <>
                              {
                                data?.extra?.discountPartakeType && data?.extra?.discountPartakeType?.length === 1
                                  ? (
                                    <span>
                                      {
                                        data?.extra?.discountPartakeType?.includes('memberCard')
                                          ? i18n.t('mkt.pointCard.participatingMember')
                                          : i18n.t('mkt.pointCard.participatingOther')
                                      }
                                    </span>
                                  ) : <span>{i18n.t('mkt.pointCard.participating')}</span>
                              }
                            </>
                          )
                      }
                    </div>
                  </div>
              }
            </div>
          </div>
          <div className='opera-area' onClick={() => viewCoupons()}>
            <div>{i18n.t('mkt.pointCard.viewRewards')}</div>
            <i className='iconfont icon-chevron-right'></i>
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(CouponDetailModal)
